import { destructive, titles } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	tagToken: {
		maxWidth: 150,
	},
	tagTokenExclude: {
		background: '#FEF3F5',
		border: `1px solid ${destructive}`,
		color: titles,
	},
	tagTokenOpPrefix: {
		color: titles,
		fontSize: 12,
	},
});
